/*
 * @Author: ailin
 * @Date: 2023-01-09 14:49:41
 * @LastEditors: ailin
 * @LastEditTime: 2023-01-13 19:58:16
 * @Description: file content
 * @FilePath: /broadcast/src/views/broadHost/components/getJob/index.ts
 */

import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/icon.css';

import { Component , Vue , Watch,Prop} from "vue-property-decorator";
@Component
export default class orderList extends Vue {
    @Prop() private roomData!: any;
    params:any={
        baseId:'',
        sceneId:'',
        page_num:1,
        page_size:10,
        pageTotal:0
    }
    companyList:any = []
    loading:boolean = false
    isOrderManage:boolean = true // 弹窗boolean
	api:any={
		getScenceRecruitCompany:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/recruit/getScenceRecruitCompany",//查询当前场次下招聘公司
		delScenceRecruitCompany:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/recruit/delScenceRecruitCompany",//删除当前场次下招聘公司
		saveScenceRecruitJob:"https://opc" + this.domain + "/ule-live-amdin/api/v1/room/recruit/saveScenceRecruitJob"//根据公司id 导入岗位
	}
    @Watch('isOrderManage') 
	onChange(val:any,oldVal:any){
        if(!val){
            this.$emit('hintChange' , {name:'isGetJob',val:val})
        }
	}
	mounted() {
        this.params.baseId = this.$route.params.id || '';
        this.params.sceneId = this.roomData.scene_id || '';
		this.getCompanyList()
	}
    
    removeCompany(item:any){
        this.$dialog.confirm({
			title: '温馨提示',
			message: `确定从这场直播中移除${item.companyName}公司吗？`,
			confirmButtonText: '确定移除',
			cancelButtonText: '取消'
		}).then(() => {
            let url = `${this.api.delScenceRecruitCompany}?id=${item.id}&baseId=${this.params.baseId}&sceneId=${this.params.sceneId}`
            this.fetch({
            	url: url,
            	method: "get",
            }).then((res:any) => {
                this.$toast('移除成功')
                this.getCompanyList();
                this.loading = false
            }).catch((err:any)=>{
                this.$toast(err.msg)
                this.loading = false
            })
        })
        
    }
    importFun(){
        if(!this.params.ids){
            return false;
        }
        let url = `${this.api.saveScenceRecruitJob}?ids=${this.params.ids}&baseId=${this.params.baseId}&sceneId=${this.params.sceneId}`
		this.fetch({
			url: url,
			method: "get",
		}).then((res:any) => {
            this.$toast('公司导入成功')
            this.params.page_num=1;
            this.getCompanyList();
            this.loading = false
		}).catch((err:any)=>{
            this.$toast(err.msg)
            this.loading = false
		})
    }
	getCompanyList(){//获取公司列表
        let url = `${this.api.getScenceRecruitCompany}?pageNum=${this.params.page_num}&pageSize=${this.params.page_size}&baseId=${this.params.baseId}&sceneId=${this.params.sceneId}`
		this.fetch({
			url: url,
			method: "get",
		}).then((res:any) => {
			if(res){
                this.params.pageTotal = Math.ceil(res.count / this.params.page_size)
                this.companyList = res.recruitCompanyList || [];
			}
            this.loading = false
		}).catch((err:any)=>{
            this.$toast(err.msg)
            this.loading = false
		})		
	}
}
